import L from "leaflet";
import ReactDOMServer from "react-dom/server";
import { Marker, useMap } from "react-leaflet";
import { offsetPosition } from "../utils/offsetPosition";
import "./LeafletPopup.css";
import NetworkElementTooltip from "./network-element-tooltip/NetworkElementTooltip";

const LctBadge = ({ asset, position, lctType, onClick, showTooltip }) => {
  const map = useMap();

  const badge = L.divIcon({
    className: "countMarker",
    html: ReactDOMServer.renderToString(
      <div className={`badge rounded-pill text-light p-0`}>
        <span
          style={{
            display: "inline-block",
            fontSize: ".9rem",
            padding: ".125rem .25rem",
          }}
        >
          <small>
            <i className={`icon-${lctType}`}></i>
          </small>
        </span>
      </div>,
    ),
  });

  return (
    <Marker
      eventHandlers={{
        click: (e) => {
          onClick(asset);
        },
      }}
      id={asset.id}
      className="counter-badge"
      position={offsetPosition(map, asset.geometry, position[0], position[1])}
      icon={badge}
    >
      <NetworkElementTooltip
        asset={asset}
        lctType={lctType}
        offset={[-30, 4]}
        enabled={showTooltip}
      />
    </Marker>
  );
};

export default LctBadge;
